import { Component } from '@angular/core';

@Component({
  selector: 'app-underground-tank-icon',
  templateUrl: './underground-tank-icon.component.svg',
  styleUrls: ['./underground-tank-icon.component.scss']
})
export class UndergroundTankIconComponent
{

  constructor() { }

}
